export default __webpack_public_path__ + "ec7723ea62ad74c149591d450f7f3674.ttf";